import { render, staticRenderFns } from "./cashMoney.vue?vue&type=template&id=2d548820&scoped=true"
import script from "./cashMoney.vue?vue&type=script&lang=js"
export * from "./cashMoney.vue?vue&type=script&lang=js"
import style0 from "./cashMoney.vue?vue&type=style&index=0&id=2d548820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d548820",
  null
  
)

export default component.exports